import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";
import { CubiqMessage } from "./CubiqMessage";

export class CubiqEvent {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();
  public encodableType: string;
  public msgId: string;
  constructor() {}
  public getMessageId() {
    return this.msgId;
  }
  public getEncodableType(): string {
    return this.encodableType;
  }
  public decode(cubiqMessage: CubiqMessage): void {
    this.encodableType = this.baseEncoder.readObject(
      false,
      false,
      "java.lang.String",
      cubiqMessage.getMessage(),
    );
    this.msgId = this.baseEncoder.readObject(
      false,
      false,
      "java.lang.String",
      cubiqMessage.getMessage(),
    );
  }

  public toString(): string {
    return "encodableType:" + this.encodableType;
  }
}
